<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD"><strong>Contents</strong></h1>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/int.htm">Introduction…</a></strong></h2>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/c01.htm">Tools &amp; Equipment</a></strong></h2>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/c02.htm">Cake Recipes</a></strong></h2>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c02.htm#c2">Vanilla</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c02.htm#c3">Chocolate</a> </strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c02.htm#c4">Vanilla Buttercream</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c02.htm#c5">Chocolate Buttercream</a></strong></p>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/c03.htm">Techniques</a></strong></h2>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c03.htm#c6">Making Push Pops</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c03.htm#c7">Colouring</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c03.htm#c8">Decorating</a></strong></p>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/c04.htm">Sensational Seasons</a></strong></h2>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c04.htm#c9">Snowflake Wishes</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c05.htm">Christmas Pudding</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c06.htm">Pumpkin Patch</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c07.htm">Bump in the Night</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c08.htm">Down the Rabbit Hole</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c09.htm">Bunny Ears</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c10.htm">4th of July</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c11.htm">Hey Little Pilgrim</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c12.htm">Lovehearts</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c13.htm">Sealed with a Kiss</a></strong></p>
<p class="TOC-CH-SUB"><strong><a href="#/OEBPS/c14.htm">New Year’s Rockin’ Eve</a></strong></p>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/c15.htm">Suppliers</a></strong></h2>
<h2 class="TOC-CH-T"><strong><a href="#/OEBPS/ata.htm">About the Author</a></strong></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4cd76ecf